module.exports = __webpack_public_path__ + "static/media/visa-card.72e0755a.svg";